import {Component, OnDestroy, OnInit} from '@angular/core';
import {LegacyAppVersionService} from './legacy-app-version.service';
import {FormFieldBase} from '../../form-data/form-field-base';
import {FormFieldString} from '../../form-data/form-field-string';
import {FormFieldArea} from '../../form-data/form-field-area';
import {FormFieldCheckbox} from '../../form-data/form-field-checkbox';
import {FormFieldMultiselect} from '../../form-data/form-field-multiselect';
import {LegacyAppVersion} from './legacy-app-version.model';
import {cloneDeep, isBoolean} from 'lodash-es';
import {ServiceAnswer} from '../../shared/service-answer';

// TODO: delete this component after the new update system has been deployed
@Component({
  selector: 'qm-app-version',
  templateUrl: './app-version.component.html',
  styleUrls: ['./app-version.component.scss']
})
export class AppVersionComponent implements OnInit, OnDestroy {
  public fields: FormFieldBase<any>[];
  public formName: string;
  public selectedTab = 'app-versions';
  public appVersions: ServiceAnswer<LegacyAppVersion[]>;
  private formData: LegacyAppVersion;
  private old: LegacyAppVersion;

  constructor(private appVersionService: LegacyAppVersionService) {
    console.log('INIT APP VERSION!');
  }

  ngOnInit() {
    this.updateAppVersions();
    this.formName = 'appVersionForm';
    this.fields = [
      new FormFieldMultiselect({
        key: 'customizedTenants',
        label: 'Asiakaskohtaisia muutoksia',
        value: null,
        required: false,
        order: 1,
        options: [{key: 1, value: 1}, {key: 2, value: 2}, {key: 3, value: 3}, {key: 4, value: 4}, {key: 5, value: 5},
          {key: 6, value: 6},
          {key: 7, value: 7},
          {key: 8, value: 8},
          {key: 9, value: 9}]
      }),
      new FormFieldArea({
        key: 'generalDescription',
        label: 'Päivityksen kuvaus',
        value: null,
        required: true,
        order: 3,
        rows: 8
      }),
      new FormFieldArea({
        key: 'vivoDescription',
        label: 'VIVO -muutokset',
        value: null,
        required: false,
        order: 5,
        rows: 3
      }),
      new FormFieldCheckbox({
        key: 'forcedUpdate',
        label: 'Pakotettu päivitys',
        value: false,
        required: false,
        order: 8
      }),
      new FormFieldCheckbox({
        key: 'resetCache',
        label: 'Resetoi välimuisti',
        value: false,
        required: false,
        order: 12
      }),
      new FormFieldString({
        key: 'versionNumber',
        label: 'Versionumero',
        value: null,
        required: true,
        order: 22
      })
    ];
  }

  ngOnDestroy() {
    console.log('DESTROY APP VERSION!');
  }

  public async formSubmit(newData: LegacyAppVersion): Promise<void> {
    console.log(newData);
    console.log('SUBMIT');
    const appVersion = new LegacyAppVersion();
    appVersion.generalDescription = newData.generalDescription;
    appVersion.tenantSpecificDescription = [];
    appVersion.vivoDescription = newData.vivoDescription;
    appVersion.forcedUpdate = isBoolean(newData.forcedUpdate) ? newData.forcedUpdate : false;
    appVersion.resetCache = isBoolean(newData.resetCache) ? newData.resetCache : false;
    appVersion.versionNumber = newData.versionNumber;
    if (newData.customizedTenants) {
      newData.customizedTenants.forEach(tenant => {
        appVersion.tenantSpecificDescription.push({tenantId: tenant, description: newData['tenant_' + tenant]});
      });
    }
    console.log(appVersion);
    let r: ServiceAnswer<LegacyAppVersion>;
    if (this.old) {
      appVersion.id = this.old.id;
      appVersion.createdAt = this.old.createdAt;
      r = await this.appVersionService.edit(appVersion);
    } else {
      r = await this.appVersionService.create(appVersion);
    }
    if (r.isOk) {
      this.old = null;
      this.updateAppVersions();
    }
  }

  public formChanged(newData: LegacyAppVersion) {
    this.updateForm(newData);
    this.formData = cloneDeep(newData);
  }

  public editUpdate(version: LegacyAppVersion) {
    version.customizedTenants = version.tenantSpecificDescription.map(o => {
      version['tenant_' + o.tenantId] = o.description;
      return o.tenantId;
    });
    this.old = version;
    this.formChanged(version);
  }

  private updateForm(newData: LegacyAppVersion) {
    if (newData.customizedTenants) {
      newData.customizedTenants.forEach(tenantNumber => {
        const field = this.fields.find(o =>
          o.key === 'tenant_' + tenantNumber
        );
        if (!field) {
          this.fields.push(new FormFieldArea({
            key: 'tenant_' + tenantNumber,
            label: 'Asiakkaan ' + tenantNumber + ' muutokset',
            value: '',
            required: true,
            order: 6,
            rows: 5
          }));
        }
      });
    }
    this.fields = this.fields.filter(field => {
      if (field.key.startsWith('tenant')) {
        const tenant = parseInt(field.key.substring(field.key.indexOf('_') + 1));
        return newData.customizedTenants.indexOf(tenant) !== -1;
      } else {
        return true;
      }
    }).map(field => {
      field.value = newData[field.key];
      return field;
    });
  }

  private async updateAppVersions(): Promise<void> {
    this.appVersions = await this.appVersionService.list();
  }

}
